import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class HttpStatus403Interceptor implements HttpInterceptor {
  constructor(private _snackBar: MatSnackBar) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(
        err => {
          if (err instanceof HttpErrorResponse) {
            if (err.status !== 403) {
              return;
            }

            this._snackBar.open('Access to the requested resource is not allowed', 'Ok', {
              duration: 5000,
            });
          }
        }));
  }
}
